import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedDataAccessWebappModule } from '@mode/shared/data-access-webapp';
import { SharedUtilCappieReporterModule } from '@mode/shared/util-cappie-reporter';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReportChartViewerFacade } from './report-chart-viewer.facade';
import { ReportDbtMetadataEffects } from './report-dbt-metadata/report-dbt-metadata.effects';
import * as fromReportDbtMetadata from './report-dbt-metadata/report-dbt-metadata.reducer';
import * as fromReportFilter from './report-filter/report-filter.reducer';
import { ReportViewerObservabilityService } from './report-viewer-observability.service';
import { ReportViewerFacade } from './report-viewer.facade';
import { ReportViewerEffects } from './report-viewer/report-viewer.effects';
import * as fromReportViewer from './report-viewer/report-viewer.reducer';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { ChartsDomainModule } from '@mode/charts/domain';

const EFFECTS: any[] = [ReportViewerEffects, ReportDbtMetadataEffects];

@NgModule({
  imports: [
    CommonModule,
    ChartsDomainModule,
    SharedDataAccessWebappModule,
    SharedUtilCappieReporterModule,
    EffectsModule.forFeature(EFFECTS),
    StoreModule.forFeature(fromReportViewer.reportViewerFeatureKey, fromReportViewer.reducer),
    StoreModule.forFeature(fromReportFilter.reportFilterFeatureKey, fromReportFilter.reducer),
    StoreModule.forFeature(fromReportDbtMetadata.reportDbtMetadataFeatureKey, fromReportDbtMetadata.reducer),
  ],
  providers: [ReportChartViewerFacade, ReportViewerFacade, ReportViewerObservabilityService],
})
export class ReportViewerDomainModule {}
